var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M87.232 21.607l-8.839-8.839-28.393 28.393-28.393-28.393-8.839 8.838 28.393 28.393-28.393 28.393 8.839 8.839 28.393-28.393 28.393 28.393 8.839-8.839-28.393-28.393z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }